import React, { useState, useEffect, } from 'react'
import HtmlParser from 'react-html-parser';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';

import $ from 'jquery';
import 'react-tempusdominus-bootstrap';
import Swal from 'sweetalert2';
import axios from 'axios';

import Menu from '../main/Menu';
import PurchasePaymentAddEditDetail from './PurchasePaymentAddEditDetail';
import { purchasePaymentDataGetAsync, purchaseStatusGet } from '../../controllers/purchases/purchases';
import { purchasePaymentModelGet, } from '../../models/expenses/purchasePayment';

import {
    checkIfUserIsMaster, dataTableLanguaje, buttonProcessGet, responseGet, globalSettings, sendMessage, styles, separatorsNumbersSet, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet,
    awaitDelay, processEvaluateGet, languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings';
import useAuth from '../../controllers/users/useAuth';
import PurchaseFiles from './PurchaseFiles';
import BuildingHeader from '../buildings/BuildingHeader';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';
import { purchaseModelGet } from '../../models/expenses/purchase';
import { supplierModelGet } from '../../models/expenses/suppliers';
import { paymentMethodModelGet } from '../../models/paymentMethods/paymentMethod';

const currentMethod = 'PurchasePayments';

export default function PurchasePayments({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region others
    let result;
    let dataObj = {};
    let headerObj = {};
    let swalProperties = {};
    const { id, } = useParams();
    const auth = useAuth();
    //const history = useHistory();
    const neutralValue = 0.00;
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const [showView, setShowView] = useState(false);
    const [processType, setProcessType] = useState(0);
    const [showLoading, setShowLoading] = useState({ building: true, purchase: true, payments: true, });
    const [isEditDelete, setIsEditDelete] = useState(false);
    //#endregion others

    //#region building
    const [building, setBuilding] = useState(buildingModelGet({}));
    //#endregion building

    //#region banks
    const [banks, setBanks] = useState([]);
    const [bankOrigins, setBankOrigins] = useState([]);
    //#endregion banks

    //#region bank accounts
    const [bankAccounts, setBankAccounts] = useState([]);
    //#endregion bank accouns

    //#region collection cash
    const [collectionCashes, setCollectionCashes] = useState([]);
    //#endregion collection cash

    //#region purchase
    const [purchaseDate, setPurchaseDate] = useState('');
    const [purchase, setPurchase] = useState(purchaseModelGet({}));
    //#endregion purchase

    //#region Payment methods
    const [paymentMethods, setPaymentMethods] = useState([]);
    //#endregion Payment methods

    //#region suppliers
    const [suppliers, setSuppliers] = useState([]);
    const chkSupplierNationalId = 'chkSupplierNational';
    //#endregion suppliers

    //#region purchase payments
    //let purchasePaymentTwo = {};
    const dtPurchasePaymentsId = 'dtPurchaseDetails';
    const [dtPurchasePaymentsRowIndex, setDtPurchasePaymentsRowIndex] = useState(0);
    const [purchasePaymentShowModal, setPurchasePaymentShowModal] = useState(false);
    const [purchasePayment, setPurchasePayment] = useState(purchasePaymentModelGet({}));
    const [purchasePaymentAddEditDetailDelete, setPurchasePaymentAddEditDetailDelete] = useState({
        id: '',
        description: '',
        rowIndex: 0,
        processType: 0,
        //purchasePayment: purchasePaymentModelGet({}),
        subMethod: '',
    });
    //#endregion purchase payments

    //#region attachment
    const [btnAttachmentDisabled, setBtnAttachmentDisabled] = useState(true);
    const [filesShowModal, setFilesShowModal] = useState(false);
    //#endregion attachment

    //#region others
    const controls = {
        buttons: {
            edit: {
                id: 'btnEdit',
                className: 'btn btn-outline-warning mx-1',
            },
            attachment: {
                id: 'btnAttachment',
                className: 'btn btn-outline-info',
            },
            details: {
                id: 'btnDetails',
                className: 'btn btn-outline-secondary mx-1',
            },
            back: {
                id: 'btnBack',
                className: 'btn btn-outline-success',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            purchasePayments: {
                buttons: {
                    detailAdd: {
                        className: 'btn btn-sm btn-outline-success float-right mx-1',
                        id: 'btnDtPurchasePaymentsIdDetailAdd',
                    },
                    detailProcess: {
                        className: 'btn btn-sm btn-outline-info float-right',
                        id: 'btnDtPurchasePaymentsIdDetailProcess',
                    },
                    detailDelete: {
                        className: 'btn btn-sm btn-outline-danger float-right mx-1',
                        id: 'btnDtPurchasePaymentsIdDetailDelete',
                    },
                },
                icons: {
                    detailAdd: {
                        id: 'iconDtPurchasePaymentsIdDetailAdd',
                        className: globalSettings?.icons?.plusCircle,
                    },
                    detailProcess: {
                        id: 'iconDtPurchasePaymentsIdDetailProcess',
                        className: globalSettings?.icons?.fasFa?.cogs,
                    },
                    detailDelete: {
                        id: 'iconDtPurchasePaymentsIdDetailDelete',
                        className: globalSettings?.icons?.trash,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtPurchasePaymentsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtPurchasePaymentsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    detailAdd: {
                        id: 'spDtPurchasePaymentsIdDetailAdd',
                        className: '',
                    },
                    detailProcess: {
                        id: 'spDtPurchasePaymentsIdDetailProcess',
                        className: '',
                    },
                    detailDelete: {
                        id: 'spDtPurchasePaymentsIdDetailDelete',
                        className: '',
                    },
                },
            },
        },
        icons: {
            edit: {
                id: 'icoEdit',
                className: globalSettings?.icons?.edit,
            },
            attachment: {
                id: 'icoAttachment',
                className: globalSettings?.icons?.paperClip,
            },
            details: {
                id: 'icoDetails',
                className: globalSettings?.icons?.list,
            },
            back: {
                id: 'icoBack',
                className: globalSettings?.icons?.arrowCircleLeft,
            },
        },
        inputs: {
            // user: {
            //     id: 'inputUser',
            //     className: 'form-control bg-transparent',
            // },
            // title: {
            //     id: 'inputTitle',
            //     className: 'form-control bg-transparent',
            // },
            // comment: {
            //     id: 'inputComment',
            //     className: 'form-control',
            // },
            // statusComment: {
            //     id: 'inputStatusComment',
            //     className: 'form-control bg-transparent text-black',
            // },
        },
        selects: {
            // apartment: {
            //     id: 'selApartmet',
            //     className: 'form-select',
            // },
            // title: {
            //     id: 'selTitle',
            //     className: 'form-select',
            // },
            // icon: {
            //     id: 'selIcon',
            //     className: 'form-select',
            // },
            // status: {
            //     id: 'selStatus',
            //     className: 'form-select',
            // },
        },
        spinners: {
            edit: {
                id: 'spEdit',
                className: '',
            },
            attachment: {
                id: 'spAttachment',
                className: '',
            },
            details: {
                id: 'spDetails',
                className: '',
            },
            back: {
                id: 'spBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region purchase (methods)
    const localPurchaseGotoAsync = (processType) => {
        let response = responseGet();
        try {
            sendMessage(2, globalSettings?.messages?.processing?.[languageObj?.id], globalSettings?.timers?.fourthySeconds, false, true, null, '');

            switch (processType) {
                case 1:
                    window.location.href = `${globalSettings?.app?.backend?.urlPurchaseEdit}/${purchase.id}`;
                    break;
                case 2:
                    window.location.href = `${globalSettings?.app?.backend?.urlPurchaseDetail}/${purchase.id}`;
                    break;
                default:
                    break;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: localPurchaseGotoAsync<br/>`;
            response.msgText += `Error: ${ex?.message}`;
            sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
        }
        return response;
    }
    //#endregion purchase (methods)

    //#region purchase payments (methods)
    const dataTablePurchasePaymentsSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTablePurchasePaymentsSetAsync';
        let response = responseGet();
        try {
            $(`#${dtPurchasePaymentsId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                autoWidth: false,
                columns: [
                    { title: globalSettings?.labels?.date?.[languageObj?.id], width: '0%', orderable: false, searchable: false, visible: false, },
                    { title: globalSettings?.labels?.type?.[languageObj?.id], width: '45%', orderable: false, },
                    { title: globalSettings?.labels?.reference?.[languageObj?.id], orderable: false, width: '20%', },
                    { title: globalSettings?.labels?.date?.[languageObj?.id], orderable: false, width: '15%', },
                    { title: globalSettings?.labels?.amount?.[languageObj?.id], className: 'text-right', orderable: false, width: '15%', },
                    { title: globalSettings?.labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                info: false,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                //order: [[0, 'asc'],],
                order: [[0, 'desc'],],
                responsive: true,
                lengthChange: true,
                ordering: true,
                paging: false,
                searching: false,
                //}).buttons().container().appendTo(`#${dtPurchasePaymentsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const purchasePaymentAddEditDetailDeleteGetAsync = async ({ e = {}, id = '', description = '', rowIndex = 0, processType = 0, subMethod = '', }) => {
        const currentMethod = 'purchasePaymentAddEditDetailDeleteGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region methods
            //#region old code
            //setPurchasePayment({});
            //#endregion old code
            //purchasePaymentTwo = {};

            //#region old code
            // if (processType === 0) {
            //     purchasePaymentTwo = { id, description, rowIndex, processType }
            // } else {
            //     setPurchasePayment({ id, description, rowIndex, processType });
            // }
            //#endregion old code

            setPurchasePaymentAddEditDetailDelete({
                id: id,
                description: description,
                rowIndex: rowIndex,
                processType: processType,
                subMethod: currentMethod,
            });

            $(`#${controls?.dataTables?.purchasePayments?.buttons?.detailProcess?.id}`)?.trigger('click');
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const purchasePaymentAddEditDetailDeletePostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'purchasePaymentAddEditDetailDeletePostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let idLocal = '';
            let rowIndexLocal = 0;
            let processTypeLocal = 0;
            let descriptionLocal = '';
            let purchasePaymentLocal = purchasePaymentModelGet({});
            //#endregion variables

            //#region initialize
            //#region old code
            // if (!isUndNullEmp({ data: purchasePaymentTwo, subMethod: currentMethod, })?.result) {
            //     idLocal = purchasePaymentTwo?.id;
            //     descriptionLocal = purchasePaymentTwo?.description;
            //     processTypeLocal = purchasePaymentTwo?.processType;
            //     rowIndexLocal = purchasePaymentTwo?.rowIndex;
            // } else {
            //     idLocal = purchasePayment?.id;
            //     descriptionLocal = purchasePayment?.description;
            //     processTypeLocal = purchasePayment?.processType;
            //     rowIndexLocal = purchasePayment?.rowIndex;
            // }

            // setDtPurchasePaymentsRowIndex(rowIndexLocal);
            //#endregion old code

            idLocal = purchasePaymentAddEditDetailDelete?.id;
            descriptionLocal = purchasePaymentAddEditDetailDelete?.description;
            processTypeLocal = purchasePaymentAddEditDetailDelete?.processType;
            rowIndexLocal = purchasePaymentAddEditDetailDelete?.rowIndex;
            setDtPurchasePaymentsRowIndex(rowIndexLocal);
            //#endregion initialize

            if (showView || processTypeLocal === 1 || processTypeLocal === 2) {
                //#region check if purchase is different zero
                if (processTypeLocal === 0) {
                    if (isUndNullEmp({ data: purchase?.balance, subMethod: currentMethod, })?.result || purchase?.balance <= 0.00) {
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 1,
                            msgText: globalSettings?.messages?.thisProcessAppliesOnlyToRecordsWithBalanceGreaterThanZero?.[languageObj?.id],
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }
                }
                //#endregion check if purchase is different zero

                if (processTypeLocal === 0) {
                    controlsStatusSet({ processType: 5, subMethod: currentMethod, });
                    //} else if (processTypeLocal === 1 || processTypeLocal === 2) {
                } else {
                    setShowLoading({ building: false, purchase: false, payments: true, });
                }

                //#region payments data get
                if (processType !== -1) {
                    //#region  data get
                    response = await purchasePaymentDataGetAsync({
                        buildingId: purchase?.buildingId,
                        limit: 0,
                        valueReturn: true,
                        auth: auth,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        if (processTypeLocal === 0) {
                            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                            //} else if (processTypeLocal === 1 || processTypeLocal === 2) {
                        } else {
                            setShowLoading({ building: false, purchase: false, payments: false, });
                        }
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }
                    //#endregion  data get

                    //#region data set
                    setBanks(response?.result?.banks);
                    setBankOrigins(response?.result?.bankOrigins);
                    setBankAccounts(response?.result?.bankAccounts);
                    setPaymentMethods(response?.result?.paymentMethods);
                    setCollectionCashes(response?.result?.collectionCashes);
                    //#endregion data set
                }
                //#endregion payments data get

                //#region purchase payment set
                if (processTypeLocal === 0) {
                    setPurchasePayment(
                        purchasePaymentModelGet({
                            buildingId: purchase?.buildingId,
                            purchaseId: purchase?.id,
                            paymentMethodId: '',
                            bankOriginId: '',
                            bankId: '',
                            bankAccountId: '',
                            collectionCashId: '',
                            userId: auth?.user?.uid,
                        })
                    );
                } else {
                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                            languageId: languageObj?.id,
                        },
                        url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlPurchasePayments}/${idLocal}`,
                    };

                    result = await axios?.get(
                        headerObj?.url,
                        headerObj,
                    );

                    response = result?.data;

                    if (!response?.isSuccess || response?.isWarning) {
                        if (processTypeLocal === 0) {
                            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                            //} else if (processTypeLocal === 1 || processTypeLocal === 2) {
                        } else {
                            setShowLoading({ building: false, purchase: false, payments: false, });
                        }
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    purchasePaymentLocal = response?.result;

                    if (isUndNullEmp({ data: purchasePaymentLocal, subMethod: currentMethod, })?.result) {
                        if (processTypeLocal === 0) {
                            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                            //} else if (processTypeLocal === 1 || processTypeLocal === 2) {
                        } else {
                            setShowLoading({ building: false, purchase: false, payments: false, });
                        }
                        response.msgType = 1;
                        response.isWarning = true;
                        response.msgText = `${globalSettings?.labels?.description?.[languageObj?.id]}: <b>${descriptionLocal}</b><br/>`;
                        response.msgText += `${globalSettings?.messages?.theRecordCannotBeLocated.en}<br/>`;
                        response.msgText += `${globalSettings?.messages?.pleaseTryAgain?.[languageObj?.id]}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    setPurchasePayment(purchasePaymentLocal);
                }
                //#endregion purchase payment set

                setProcessType(processTypeLocal);
                setDtPurchasePaymentsRowIndex(rowIndexLocal);

                if (processTypeLocal !== -1) {
                    setPurchasePaymentShowModal(true);
                }

                if (processTypeLocal === 0) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    //} else if (processTypeLocal === 1 || processTypeLocal === 2) {
                } else {
                    setShowLoading({ building: false, purchase: false, payments: false, });
                }

                //#region show alert to delete
                if (processTypeLocal === -1) {
                    //#region old code
                    // //#region old code
                    // // let localMsgText = `${globalSettings?.labels?.paymentMethod?.[languageObj?.id]}: <b>${descriptionLocal}</b><br/>`;
                    // // localMsgText += `${globalSettings?.labels?.reference?.[languageObj?.id]}: <b>${purchasePaymentLocal.reference}</b><br/>`;
                    // // localMsgText += `${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`;

                    // // swalProperties = {
                    // //     icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                    // //     title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
                    // //     html: localMsgText,
                    // //     timer: null,
                    // //     confirmButtonColor: globalSettings?.colors?.warningColorExp,
                    // //     confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
                    // //     showCancelButton: true,
                    // //     cancelButtonColor: globalSettings?.colors?.successColorExp,
                    // //     cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
                    // //     timerProgressBar: false,
                    // //     didOpen: () => {
                    // //         Swal.hideLoading();
                    // //     },
                    // // };

                    // // const { isConfirmed, } = await Swal.fire(swalProperties);

                    // // if (isConfirmed) {
                    // //     $(`#${controls?.dataTables?.purchasePayments?.buttons?.detailDelete?.id}`)?.trigger('click');
                    // // }
                    // //#endregion old code

                    // setPurchasePaymentAddEditDetailDelete({
                    //     ...purchasePaymentAddEditDetailDelete,
                    //     purchasePayment: purchasePaymentLocal,
                    // })
                    // $(`#${controls?.dataTables?.purchasePayments?.buttons?.detailDelete?.id}`)?.trigger('click');
                    //#endregion old code
                    let msgTextObj = {
                        one: `${globalSettings?.labels?.paymentMethod?.[languageObj?.id]}: <b>${purchasePaymentAddEditDetailDelete?.description}</b><br/>`,
                        two: `${globalSettings?.labels?.reference?.[languageObj?.id]}: <b>${purchasePaymentLocal?.reference}</b><br/>`,
                        three: `${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                    };

                    swalProperties = {
                        icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                        title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
                        html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}`,
                        timer: null,
                        backdrop: true,
                        confirmButtonColor: globalSettings?.colors?.warningColorExp,
                        confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
                        showCancelButton: true, //!Swal.isLoading(), //true,
                        cancelButtonColor: globalSettings?.colors?.successColorExp,
                        cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
                        showLoaderOnConfirm: true,
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                        preConfirm: async () => {
                            try {
                                Swal.getCancelButton().hidden = true;
                                Swal?.update({
                                    icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                                    title: `${globalSettings?.messages?.processing?.[languageObj?.id]}...`,
                                    html: `${msgTextObj?.one}${msgTextObj?.two}`,
                                    showConfirmButton: false,
                                });

                                //#region purchases delete
                                headerObj = {
                                    headers: {
                                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                        languageId: languageObj?.id,
                                    },
                                    url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlPurchasePayments}/${purchasePaymentAddEditDetailDelete?.id}`,
                                };

                                result = await axios?.delete(
                                    headerObj?.url,
                                    headerObj,
                                );

                                response = result?.data;

                                if (!response?.isSuccess || response?.isWarning) {
                                    await sendMessageCloseCurrentWindowAsync({
                                        msgType: response?.msgType,
                                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                        closeWindow: false,
                                        urlGoTo: response?.urlGoTo,
                                        auth: auth,
                                        isLogout: false,
                                        languageId: languageObj?.id,
                                        subMethod: currentMethod,
                                    });
                                    return;
                                }
                                //#endregion purchase delete

                                await dataGetAsync({
                                    queryCodeSet: false,
                                    subMethod: currentMethod,
                                });

                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: 0,
                                    msgText: `${globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                            } catch (ex) {
                                //#region Error
                                response.isSuccess = false;
                                response.msgType = -1;
                                response.msgText = `Method: ${currentMethod}<br/>`;
                                response.msgText += `Error: ${ex?.message}`;
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                });
                                //#endregion Error
                            }
                        },
                        allowOutsideClick: () => !Swal.isLoading(),
                    };

                    await Swal.fire(swalProperties);
                }
                //#endregion show alert to delete
            }
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            setShowLoading({ building: false, purchase: false, payments: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    //#region old code
    // const paymentsDataGetAsync = async (buildingId = '') => {
    //     let response = responseGet();
    //     try {
    //         response = await purchasePaymentDataGetAsync(buildingId, 0, true, auth);
    //         if (!response?.isSuccess || response?.isWarning) {
    //             return response;
    //         }

    //         setBanks(response?.result?.banks);
    //         setPaymentMethods(response?.result?.paymentMethods);
    //         setBankAccounts(response?.result?.bankAccounts);
    //         setBankOrigins(response?.result?.bankOrigins);
    //         setCollectionCashes(response?.result?.collectionCashes);
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: paymentsDataGetAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion old code

    //#region old code
    // const purchasePaymentDeletePostAsync = async ({ subMethod = '', }) => {
    //     const currentMethod = 'purchasePaymentDeletePostAsync';
    //     let response = responseGet();
    //     try {
    //         //#region old code
    //         // sendMessage(2, globalSettings?.messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //         // //#region delete purchase payment

    //         // headerObj = {
    //         //     headers: {
    //         //         authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //         //     },
    //         // };

    //         // //result = await axios.delete(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlPurchasePayments}/${purchasePayment.id}`, headerObj);
    //         // result = await axios.delete(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlPurchasePayments}/${purchasePayment.id}`, headerObj);
    //         // response = result.data;

    //         // if (!response?.isSuccess || response?.isWarning) {
    //         //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //         //     return;
    //         // }

    //         // await dataGetAsync(true);

    //         // //#endregion delete purchase payment

    //         // sendMessage(0, globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
    //         //#endregion old code

    //         let msgTextObj = {
    //             one: `${globalSettings?.labels?.purchase?.[languageObj?.id]}: <b>${purchasePaymentAddEditDetailDelete?.description}</b><br/>`,
    //             two: `${globalSettings?.labels?.reference?.[languageObj?.id]}: <b>${purchasePaymentAddEditDetailDelete?.purchasePayment?.reference}</b><br/>`,
    //             three: `${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
    //         };

    //         swalProperties = {
    //             icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
    //             title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
    //             html: `${msgTextObj?.one}${msgTextObj?.two}`,
    //             timer: null,
    //             backdrop: true,
    //             confirmButtonColor: globalSettings?.colors?.warningColorExp,
    //             confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
    //             showCancelButton: true, //!Swal.isLoading(), //true,
    //             cancelButtonColor: globalSettings?.colors?.successColorExp,
    //             cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
    //             showLoaderOnConfirm: true,
    //             didOpen: () => {
    //                 Swal.hideLoading();
    //             },
    //             preConfirm: async () => {
    //                 try {
    //                     Swal.getCancelButton().hidden = true;
    //                     Swal?.update({
    //                         icon: globalSettings?.react?.sweetAlert2?.icons?.info,
    //                         title: `${globalSettings?.messages?.processing?.[languageObj?.id]}...`,
    //                         html: `${msgTextObj?.one}`,
    //                         showConfirmButton: false,
    //                     });

    //                     //#region purchases delete
    //                     headerObj = {
    //                         headers: {
    //                             authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //                             languageId: languageObj?.id,
    //                         },
    //                         url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlPurchasePayments}/${purchasePaymentAddEditDetailDelete?.id}`,
    //                     };

    //                     result = await axios?.delete(
    //                         headerObj?.url,
    //                         headerObj,
    //                     );

    //                     response = result?.data;

    //                     if (!response?.isSuccess || response?.isWarning) {
    //                         await sendMessageCloseCurrentWindowAsync({
    //                             msgType: response?.msgType,
    //                             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
    //                             closeWindow: false,
    //                             urlGoTo: response?.urlGoTo,
    //                             auth: auth,
    //                             isLogout: false,
    //                             languageId: languageObj?.id,
    //                             subMethod: currentMethod,
    //                         });
    //                         return;
    //                     }
    //                     //#endregion purchase delete

    //                     await dataGetAsync({
    //                         queryCodeSet: false,
    //                         subMethod: currentMethod,
    //                     });

    //                     await sendMessageCloseCurrentWindowAsync({
    //                         msgType: 0,
    //                         msgText: `${globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
    //                         closeWindow: false,
    //                         urlGoTo: response?.urlGoTo,
    //                         auth: auth,
    //                         isLogout: false,
    //                         languageId: languageObj?.id,
    //                         subMethod: currentMethod,
    //                     });
    //                 } catch (ex) {
    //                     //#region Error
    //                     response.isSuccess = false;
    //                     response.msgType = -1;
    //                     response.msgText = `Method: ${currentMethod}<br/>`;
    //                     response.msgText += `Error: ${ex?.message}`;
    //                     await sendMessageCloseCurrentWindowAsync({
    //                         msgType: response?.msgType,
    //                         msgText: response?.msgText,
    //                         closeWindow: false,
    //                         urlGoTo: response?.urlGoTo,
    //                         auth: auth,
    //                         isLogout: false,
    //                         languageId: languageObj?.id,
    //                     });
    //                     //#endregion Error
    //                 }
    //             },
    //             allowOutsideClick: () => !Swal.isLoading(),
    //         };

    //         await Swal.fire(swalProperties);
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync({
    //             msgType: response?.msgType,
    //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
    //             closeWindow: false,
    //             urlGoTo: response?.urlGoTo,
    //             auth: auth,
    //             isLogout: false,
    //             languageId: languageObj?.id,
    //             subMethod: currentMethod,
    //         });
    //     }
    //     return response;
    // }
    //#endregion old code
    //#endregion purchase payments (methods)

    //#region attachment files (methods)
    const attachmentFilesAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'attachmentFilesAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            controlsStatusSet({ processType: 2, subMethod: currentMethod, });
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });

            setFilesShowModal(true);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion attachment files (methods)

    //#region methods (others)
    const dataGetAsync = async ({ queryCodeSet = false, subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ building: true, purchase: true, payments: true, });

            //#region variables
            let dtRows = [];
            let isEditLocal = false;
            let isDeleteLocal = false;
            let purchaseLocal = purchaseModelGet({});
            let buildingLocal = buildingModelGet({});
            let suppliersLocal = [supplierModelGet({})];
            let paymentMethodsLocal = [paymentMethodModelGet({})];
            let purchasePaymentsLocal = [purchasePaymentModelGet({})];
            //#endregion variables

            //#region initialize
            setPurchase({});
            setBuilding({});
            setShowView(false);
            setPurchaseDate('');
            setBtnAttachmentDisabled(false);
            //#endregion initialize

            //#region dataTable set / set data in datatable
            response = await dataTablesSetAsync({
                queryCodeSet: queryCodeSet,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, purchase: false, payments: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return
            }

            $(`#${dtPurchasePaymentsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            //#endregion dataTable set / set data in datatable

            //#region data get
            //#region purchase get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlPurchases}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, purchase: false, payments: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            purchaseLocal = response?.result?.purchase;
            setPurchase(purchaseLocal);
            setPurchaseDate(
                dateTimeFormatGlobalSet({
                    date: purchaseLocal?.date,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result
            );
            //#endregion purchase get

            //#region suppliers get
            suppliersLocal = response?.result?.suppliers;
            setSuppliers(suppliersLocal);
            //#endregion suppliers get

            //#region building get
            buildingLocal = response?.result?.building;
            setBuilding(buildingLocal);
            //#endregion building get

            //#region purchase get payments
            dataObj = {
                conditionals: [
                    { field: globalSettings?.collections?.properties?.buildingId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${purchaseLocal?.buildingId}`, },
                    { field: globalSettings?.collections?.properties?.purchaseId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${purchaseLocal?.id}`, },
                ],
                ordersBy: [
                    { field: globalSettings?.collections?.properties?.date, value: 'asc' }
                ],
                buildingId: purchaseLocal?.buildingId,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlPurchasePayments}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, purchase: false, payments: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            //#region payment methods get
            paymentMethodsLocal = response?.result?.paymentMethods;

            if (isUndNullEmp({ data: paymentMethodsLocal, subMethod: currentMethod, })?.result || paymentMethodsLocal?.length <= 0) {
                setShowLoading({ building: false, purchase: false, payments: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: globalSettings?.messages?.youMustCreateLeastOnePaymentMethod?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion payment methods get

            purchasePaymentsLocal = response?.result?.purchasePayments || [];
            if (!isUndNullEmp({ data: purchasePaymentsLocal, subMethod: currentMethod, })?.result && purchasePaymentsLocal?.length > 0) {
                purchasePaymentsLocal?.forEach((detail) => {
                    //#region variables
                    const dtDataRow = {
                        date: dateTimeFormatGlobalSet({
                            date: detail?.date,
                            type: globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo,
                            format: 24,
                            addTime: false,
                            secondsShow: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                        description: detail?.paymentMethod?.description,
                        reference: detail?.reference,
                        purchasePaymentDate: dateTimeFormatGlobalSet({
                            date: detail?.date,
                            type: languageObj?.format?.date?.f1,
                            format: 0,
                            addTime: false,
                            secondsShow: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                        amount: separatorsNumbersSet({
                            number: detail?.amount,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                    };
                    //#endregion variables
                    //#region methods
                    dtRows.push([
                        dtDataRow?.date,
                        dtDataRow?.description,
                        dtDataRow?.reference,
                        dtDataRow?.purchasePaymentDate,
                        dtDataRow?.amount,
                        buttonProcessGet({
                            id: detail?.id,
                            description: detail?.paymentMethod?.description,
                            showDetails: true,
                            labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                            enabledDetails: true,
                            showEdit: true,
                            labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                            enabledEdit: processEvaluateGet({
                                object: detail,
                                property: globalSettings?.labels?.process?.en?.toLowerCase(),
                                process: globalSettings?.labels?.edit?.en?.toLowerCase(),
                                subMethod: currentMethod,
                            })?.result,
                            showDelete: true,
                            labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                            enabledDelete: processEvaluateGet({
                                object: detail,
                                property: globalSettings?.labels?.process?.en?.toLowerCase(),
                                process: globalSettings?.labels?.delete?.en?.toLowerCase(),
                                subMethod: currentMethod
                            })?.result,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result,
                    ]);
                    //#endregion methods
                });
            }
            //#endregion purchase get payments               
            //#endregion data get

            //#region check if editable or not
            setShowView(true);

            isEditLocal = processEvaluateGet({
                object: buildingLocal,
                property: globalSettings?.labels?.process?.en?.toLowerCase(),
                process: globalSettings?.labels?.edit?.en?.toLowerCase(),
                subMethod: currentMethod,
            })?.result;
            isDeleteLocal = isEditLocal;
            setIsEditDelete(!(isEditLocal && isDeleteLocal));
            //#endregion check if editable or not

            //#region data in datatable set
            $(`#${dtPurchasePaymentsId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            //#endregion data in datatable set

            setShowLoading({ building: false, purchase: false, payments: false, });
        } catch (ex) {
            setShowLoading({ building: false, purchase: false, payments: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTablesSetAsync = async ({ queryCodeSet = false, subMethod = '', }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            //#region dataTables set
            response = await dataTablePurchasePaymentsSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion dataTables set

            //#region query set
            if (queryCodeSet) {
                response = await queryCodeSetAsync({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }
            //#endregion query set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region variables
            $(`#${dtPurchasePaymentsId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtPurchasePaymentsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            purchasePaymentAddEditDetailDeleteGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod, });
                            break;
                        case 'details':
                            purchasePaymentAddEditDetailDeleteGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            purchasePaymentAddEditDetailDeleteGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: -1, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion variables
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const goToBackAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'goToBackAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            controlsStatusSet({ processType: 4, subMethod: currentMethod, });
            //response = await errorsDefaultSetAsync({ subMethod: currentMethod });
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            window.location.href = globalSettings?.app?.backend?.urlPurchases;
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.dataTables?.purchasePayments?.icons?.detailAdd?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchasePayments?.buttons?.detailAdd?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchasePayments?.spinners?.detailAdd?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.purchasePayments?.icons?.detailAdd?.id}`)?.addClass(controls?.dataTables?.purchasePayments?.icons?.detailAdd?.className);
                    $(`#${controls?.dataTables?.purchasePayments?.buttons?.detailAdd?.id}`)?.addClass(controls?.dataTables?.purchasePayments?.buttons?.detailAdd?.className);
                    $(`#${controls?.dataTables?.purchasePayments?.spinners?.detailAdd?.id}`)?.addClass(controls?.dataTables?.purchasePayments?.spinners?.detailAdd?.className);

                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.edit?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.edit?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.attachment?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.attachment?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.icons?.details?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.details?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 4:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 5:
                    $(`#${controls?.dataTables?.purchasePayments?.icons?.detailAdd?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.purchasePayments?.spinners?.detailAdd?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            // $(`#${controls?.inputs?.purchaseNumber?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.date?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.selects?.suppliers?.id}`).attr('disabled', (processType !== 0));
            // $(`#${controls?.inputs?.purchaseNumberSupplier?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.purchaseControlNumberSupplier?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.remark?.id}`).attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.purchasePayments?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.purchasePayments?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.buttons?.edit?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.attachment?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.details?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.dataTables?.purchasePayments?.buttons?.detailAdd?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            queryCodeSet: true,
            subMethod: 'form - onLoad',
        })
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='expenses' process='purchases' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{globalSettings?.labels?.purchases?.[languageObj?.id]} ({globalSettings?.labels?.payments?.[languageObj?.id]?.toLowerCase()})</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{globalSettings?.labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item'><Link to={globalSettings?.app?.backend?.urlPurchases}>{globalSettings?.labels?.purchases?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{globalSettings?.labels?.payments?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {/*buildings*/}
                        <BuildingHeader buildingsId={''}
                            building={building}
                            buildings={[]}
                            btnSyncDisabled={''}
                            methodGetAsync={null}
                            processType={1}
                            headerSectionValues={{}}
                            showLoading={showLoading?.building}
                            languageObj={languageObj} />

                        {/*purchase*/}
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='card card-outline card-primary shadow' >
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.purchase}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={globalSettings?.labels?.purchase?.[languageObj?.id]} src={globalSettings?.images?.invoiceLogo} style={styles?.cardHeaderLogo}></img> - {globalSettings?.labels?.purchase?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={globalSettings?.icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div className='card-body'>
                                        <div className='row text-muted'>
                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    {/*<i className={globalSettings?.icons?.sortNumericUpAlt}></i>*/}{HtmlParser(`   ${globalSettings?.labels?.number?.[languageObj?.id]}: <b>${purchase?.number || 0}</b>`)}
                                                </div>
                                            </div>

                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    {purchaseStatusGet({
                                                        purchase: purchase,
                                                        showStateLabel: true,
                                                        htmlParser: true,
                                                        languageId: languageObj?.id,
                                                        subMethod: 'lbl - purchaseStatus',
                                                    })?.result}
                                                </div>
                                            </div>

                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    {/*<i className={globalSettings?.icons?.calendarAlt}></i>*/}{HtmlParser(`   ${globalSettings?.labels?.date?.[languageObj?.id]}: <b>${purchaseDate || ''}</b>`)}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row text-muted'>
                                            <div className='col-md-8'>
                                                <div className='form-group'>
                                                    {/*<span className={globalSettings?.icons?.userTag}></span>*/}{HtmlParser(`   ${globalSettings?.labels?.supplier?.[languageObj?.id]}: <b>${suppliers?.find(({ id }) => id === purchase?.supplierId || '')?.description || ''}</b>`)}
                                                </div>
                                            </div>
                                            <div className='col-md-4'>
                                                <div className='form-group text-muted'>
                                                    {/* <div className='input-group'> */}
                                                    <div className='icheck-primary d-inline'>
                                                        <input checked={suppliers?.find(({ id }) => id === purchase?.supplierId || '')?.national || false}
                                                            id={chkSupplierNationalId}
                                                            //onChange={(e) => setPurchase({...purchase, national: e.target.checked,})}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.isNational?.[languageObj?.id]}
                                                            type='checkbox' />
                                                        <label htmlFor={chkSupplierNationalId}
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.isNational?.[languageObj?.id]}>{globalSettings?.labels?.isNational?.[languageObj?.id]}?
                                                        </label>
                                                    </div>
                                                    {/* </div> */}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row text-muted'>
                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    {/*<span className={globalSettings?.icons?.sortNumericUpAlt}></span>*/}{HtmlParser(`   ${globalSettings?.labels?.invoiceNumber?.[languageObj?.id]} (${globalSettings?.labels?.supplier?.[languageObj?.id]}): <b>${purchase?.invoiceNumber || ''}</b>`)}
                                                </div>
                                            </div>
                                            <div className='col-md-4'>
                                            </div>
                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    {/*<span className={globalSettings?.icons?.fileContract}></span>*/}{HtmlParser(`   ${globalSettings?.labels?.controlNumber?.[languageObj?.id]} (${globalSettings?.labels?.supplier?.[languageObj?.id]}): <b>${purchase?.invoiceControlNumber || ''}</b>`)}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row text-muted'>
                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    {/*<span className={globalSettings?.icons?.fasFa?.tag}></span>*/}{HtmlParser(`   ${globalSettings?.labels?.remark?.[languageObj?.id]} : <b>${purchase?.description?.replaceAll('\n', '<br/>') || ''}</b>`)}
                                                </div>
                                            </div>

                                            <div className='col-md-6'>
                                                <div className='table-responsive'>
                                                    <table className='table table-sm'>
                                                        <tbody>
                                                            <tr>
                                                                <th style={{ width: '50%' }}>{globalSettings?.labels?.subTotal?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{
                                                                    //separatorsNumbersSet(!isUndefined(purchase.subTotal) ? purchase.subTotal : neutralValue).result
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.subTotal || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'lbl - purchaseSubTotal'
                                                                    })?.result
                                                                }</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{globalSettings?.labels?.taxBase?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{
                                                                    //separatorsNumbersSet(!isUndefined(purchase.taxBase) ? purchase.taxBase : neutralValue).result
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.taxBase || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'lbl - purchaseTaxBase'
                                                                    })?.result
                                                                }</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{globalSettings?.labels?.exemptAmount?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{
                                                                    //separatorsNumbersSet(!isUndefined(purchase.exemptAmount) ? purchase.exemptAmount : neutralValue).result
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.exemptAmount || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'lbl - purchaseExemptAmount'
                                                                    })?.result
                                                                }</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{globalSettings?.labels?.tax?.[languageObj?.id]} ({
                                                                    //separatorsNumbersSet(!isUndefined(purchase.taxPercentage) ? purchase.taxPercentage : neutralValue).result
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.taxPercentage || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'lbl - purchaseTaxPercentage'
                                                                    })?.result
                                                                } %):</th>
                                                                <td className='text-right'>{
                                                                    //separatorsNumbersSet(!isUndefined(purchase.taxAmount) ? purchase.taxAmount : neutralValue).result
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.taxAmount || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'lbl - purchaseTaxAmount'
                                                                    })?.result
                                                                }</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{globalSettings?.labels?.total?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{
                                                                    //separatorsNumbersSet(!isUndefined(purchase.total) ? purchase.total : neutralValue).result
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.total || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'lbl - purchaseTotal'
                                                                    })?.result
                                                                }</td>
                                                            </tr>
                                                            <tr>
                                                                <th>{globalSettings?.labels?.balance?.[languageObj?.id]}:</th>
                                                                <td className='text-right'>{
                                                                    //separatorsNumbersSet(!isUndefined(purchase.balance) ? purchase.balance : neutralValue).result
                                                                    separatorsNumbersSet({
                                                                        number: purchase?.balance || neutralValue,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'lbl - purchaseBalance'
                                                                    })?.result
                                                                }</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='card-footer'>
                                        <div className='form-group text-right'>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*purchasePayments*/}
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='card card-outline card-primary shadow' >
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.payments}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={globalSettings?.labels?.purchase?.[languageObj?.id]} src={globalSettings?.images?.paymentsLogo} style={styles?.cardHeaderLogo}></img> - {globalSettings?.labels?.payments?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={globalSettings?.icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div className='card-body'>
                                        <div className='row text-muted'>
                                            <div className='col-md-12'>
                                                <button id={controls?.dataTables?.purchasePayments?.buttons?.detailAdd?.id}
                                                    className={controls?.dataTables?.purchasePayments?.buttons?.detailAdd?.className}
                                                    disabled={!showView || isEditDelete}
                                                    onClick={(e) => purchasePaymentAddEditDetailDeleteGetAsync({ e: e, id: '', description: '', rowIndex: 0, processType: 0, subMethod: 'btn - purchasePaymentAdd', })}
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.addPayment}
                                                    type='button'>
                                                    <i id={controls?.dataTables?.purchasePayments?.icons?.detailAdd?.id} className={controls?.dataTables?.purchasePayments?.icons?.detailAdd?.className} /> <span id={controls?.dataTables?.purchasePayments?.spinners?.detailAdd?.id} className='' aria-hidden='true'></span>
                                                </button>

                                                <button id={controls?.dataTables?.purchasePayments?.buttons?.detailProcess?.id}
                                                    className={controls?.dataTables?.purchasePayments?.buttons?.detailProcess?.className}
                                                    disabled={!showView}
                                                    hidden={true}
                                                    onClick={(e) => purchasePaymentAddEditDetailDeletePostAsync({ e: e, subMethod: 'btn - purchasePaymentProcess' })}
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.process?.[languageObj?.id]}
                                                    type='button'>
                                                    <i id={controls?.dataTables?.purchasePayments?.icons?.detailProcess?.id} className={controls?.dataTables?.purchasePayments?.icons?.detailProcess?.className} /> <span id={controls?.dataTables?.purchasePayments?.spinners?.detailProcess?.id} className='' aria-hidden='true'></span>
                                                </button>

                                                {/* {<button id={controls?.dataTables?.purchasePayments?.buttons?.detailDelete?.id}
                                                    className={controls?.dataTables?.purchasePayments?.buttons?.detailDelete?.className}
                                                    disabled={!showView || isEditDelete}
                                                    hidden={true}
                                                    onClick={(e) => purchasePaymentDeletePostAsync()}
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.process?.[languageObj?.id]}
                                                    type='button'>
                                                    <i id={controls?.dataTables?.purchasePayments?.icons?.detailDelete?.id} className={controls?.dataTables?.purchasePayments?.icons?.detailDelete?.className} /> <span id={controls?.dataTables?.purchasePayments?.spinners?.detailDelete?.id} className='' aria-hidden='true'></span>
                                                </button>} */}

                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtPurchasePaymentsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='card-footer'>
                                        <div className='form-group text-right'>
                                            <button id={controls?.buttons?.edit?.id}
                                                className={controls?.buttons?.edit?.className}
                                                disabled={isEditDelete}
                                                onClick={() => localPurchaseGotoAsync(1)}
                                                tooltip='tooltip'
                                                title={globalSettings?.labels?.edit?.[languageObj?.id]}
                                                type='button'>
                                                <i id={controls?.icons?.edit?.id} className={controls?.icons?.edit?.className} /> <span id={controls?.spinners?.edit?.id} className='' aria-hidden='true'></span>
                                            </button>
                                            <button id={controls?.buttons?.attachment?.id}
                                                className={controls?.buttons?.attachment?.className}
                                                disabled={btnAttachmentDisabled}
                                                onClick={(e) => attachmentFilesAsync({ e: e, subMethod: 'btn - attachment', })}
                                                tooltip='tooltip'
                                                title={globalSettings?.labels?.toAttach?.[languageObj?.id]}
                                                type='button'>
                                                <i id={controls?.icons?.attachment?.id} className={controls?.icons?.attachment?.className} /> <span id={controls?.spinners?.attachment?.id} className='' aria-hidden='true'></span>
                                            </button>
                                            <button id={controls?.buttons?.details?.id}
                                                className={controls?.buttons?.details?.className}
                                                onClick={() => localPurchaseGotoAsync(2)}
                                                tooltip='tooltip'
                                                title={globalSettings?.labels?.details?.[languageObj?.id]}
                                                type='button'>
                                                <i id={controls?.icons?.details?.id} className={controls?.icons?.details?.className} /> <span id={controls?.spinners?.details?.id} className='' aria-hidden='true'></span>
                                            </button>
                                            <button id={controls?.buttons?.back?.id}
                                                className={controls?.buttons?.back?.className}
                                                onClick={(e) => goToBackAsync({ e: e, subMethod: 'btn - back', })}
                                                tooltip='tooltip'
                                                title={globalSettings?.labels?.back?.[languageObj?.id]}
                                                type='button'>
                                                <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

            </div>

            {purchasePaymentShowModal ?
                <PurchasePaymentAddEditDetail $={$}
                    auth={auth}
                    purchase={purchase}
                    setPurchase={setPurchase}
                    purchasePayment={purchasePayment}
                    setPurchasePayment={setPurchasePayment}
                    purchasePaymentDataGetAsync={dataGetAsync}
                    dtId={dtPurchasePaymentsId}
                    rowIndex={dtPurchasePaymentsRowIndex}
                    paymentMethods={paymentMethods}
                    banks={banks}
                    bankOrigins={bankOrigins}
                    bankAccounts={bankAccounts}
                    collectionCashes={collectionCashes}
                    showModal={purchasePaymentShowModal}
                    setShowModal={setPurchasePaymentShowModal}
                    setShowView={setShowView}
                    processType={processType}
                    setProcessType={setProcessType} />
                :
                <></>
            }

            {filesShowModal ?
                <PurchaseFiles $={$}
                    auth={auth}
                    userRole={userRole}
                    showModal={filesShowModal}
                    setShowModal={setFilesShowModal}
                    purchase={purchase}
                    setPurchase={setPurchase}
                    languageObj={languageObj} />
                :
                <></>
            }

        </div>
    )
}